import reducer from './reducer'

import * as dealsOperations from './operations'
import * as dealsSelectors from './selectors'

export { dealsOperations, dealsSelectors }

export default reducer
